/* */ 
var $ = require('./$'),
    toIObject = require('./$.to-iobject');
module.exports = function(object, el) {
  var O = toIObject(object),
      keys = $.getKeys(O),
      length = keys.length,
      index = 0,
      key;
  while (length > index)
    if (O[key = keys[index++]] === el)
      return key;
};
